import * as React from 'react';

import { Chip, FiltersButton } from '../../components/RedesignedFilters';
import { useOpenFilters } from '../../hooks/useOpenFilters';

export const FiltersChipContainer = () => {
  const openFilters = useOpenFilters();

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      openFilters();
    },
    [openFilters],
  );

  return (
    <Chip hasChevron={false} asButton={false}>
      <FiltersButton hasActiveFilters onClick={handleClick} />
    </Chip>
  );
};
